import { create } from "zustand";

const ZustandFinancingBank = create((set) => ({
    buttonTaxItauIsSelect: false, 
    setButtonTaxItauIsSelect: (value) => set({ buttonTaxItauIsSelect: value }),

    buttonTaxBradescoIsSelect: false, 
    setButtonTaxBradescoIsSelect: (value) => set({ buttonTaxBradescoIsSelect: value }),
    
    buttonTaxCaixaIsSelect: false, 
    setButtonTaxCaixaIsSelect: (value) => set({ buttonTaxCaixaIsSelect: value }),

    buttonTaxInterIsSelect: false, 
    setButtonTaxInterIsSelect: (value) => set({ buttonTaxInterIsSelect: value }),

    buttonTaxSantanderIsSelect: false, 
    setButtonTaxSantanderIsSelect: (value) => set({ buttonTaxSantanderIsSelect: value }),

    buttonTaxBrbIsSelect: false, 
    setButtonTaxBrbIsSelect: (value) => set({ buttonTaxBrbIsSelect: value }),

    buttonTaxIsErro: false, 
    setButtonTaxIsErro: (value) => set({buttonTaxIsErro: value})
}));



export default ZustandFinancingBank;
